export default function SisPaidRectificationSummary({snapshot:s}){
 if(!s?.paymentHistory)return null;
 return <section className="rounded border border-blue-200 bg-blue-50 p-3 text-sm" aria-label="Preserved supplier payments">
  <h4 className="font-semibold">Existing supplier payments stay unchanged</h4>
  <p>Recorded allocated payments ₹{s.recordedPaymentAmount} · Original bill outstanding ₹{s.originalOutstandingBeforeAdjustment}</p>
  <p>Corrected net due after these payments ₹{s.netSupplierDueAfterRecordedPayments}</p>
  <p>A negative net due is an unapplied supplier credit, not a bank refund. No payment is released, moved or executed by this correction.</p>
  {s.paymentHistory.map(p=><p className="break-all" key={p.allocationId}>{p.date} · ₹{p.amount} · Allocation {p.allocationId} · Payment {p.paymentVoucherId}</p>)}
 </section>;
}
